/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Serve_Step_Check_DescInputs */

const en_serve_step_check_desc = /** @type {(inputs: Serve_Step_Check_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It prints a short list: what is ready and what is still missing, in plain words.`)
};

const id_serve_step_check_desc = /** @type {(inputs: Serve_Step_Check_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hasilnya daftar singkat: apa yang sudah siap dan apa yang masih kurang, dalam bahasa sehari-hari.`)
};

/**
* | output |
* | --- |
* | "It prints a short list: what is ready and what is still missing, in plain words." |
*
* @param {Serve_Step_Check_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const serve_step_check_desc = /** @type {((inputs?: Serve_Step_Check_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serve_Step_Check_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_serve_step_check_desc(inputs)
	return en_serve_step_check_desc(inputs)
});